import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';

class StockIndicator extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateStock);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateStock);
  }

  /**
   * Updates the stock indicator based on selected variant.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateStock = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newStockIndicator = event.detail.data.html.querySelector('stock-indicator');

    if (newStockIndicator) {
      // New variant has stock indicator - morph the content
      this.hidden = false;
      morph(this, newStockIndicator, { childrenOnly: true });
      // Update the progress bar
      const newProgress = newStockIndicator.querySelector('.stock-indicator__progress');
      const currentProgress = this.querySelector('.stock-indicator__progress');
      if (newProgress && currentProgress) {
        currentProgress.style.setProperty('--progress', newProgress.style.getPropertyValue('--progress'));
      }
    } else {
      // New variant doesn't have stock indicator (stock > 10 or not tracked)
      this.hidden = true;
    }
  };
}

if (!customElements.get('stock-indicator')) {
  customElements.define('stock-indicator', StockIndicator);
}
